<template>
  <div>
    <div class="back" @click="back(false)">
      <img src="@/assets/icons/icon_fh.png" alt="" srcset="">
      <span>{{ $t('admin.trainingRoom.back') }}</span>
    </div>
    <h4>{{ id ? $t('admin.trainingRoom.edit') : $t('admin.trainingRoom.create') }}</h4>
    <a-form :form="form" layout="vertical">
      <div class="title">{{ $t('admin.trainingRoom.basicInfo') }}</div>
      <div class='list'>
        <a-form-item class="full" :label="$t('admin.trainingRoom.name') + ':'" :colon="false">
          <a-input
            maxLength="30"
            :placeholder="$t('admin.trainingRoom.searchPlaceholder')"
            v-decorator="['name', { rules: [{ required: true, message: $t('admin.trainingRoom.name') + $t('admin.trainingRoom.requiredMessage') }] }]" ></a-input>
        </a-form-item>
        <a-form-item class="full" :label="$t('admin.trainingRoom.place') + ':'" :colon="false">
          <a-input
            maxLength="20"
            :placeholder="$t('admin.trainingRoom.place')"
            v-decorator="['place', { rules: [{ required: true, message: $t('admin.trainingRoom.place') + $t('admin.trainingRoom.requiredMessage') }] }]"></a-input>
        </a-form-item>
      </div>
      <div class='list'>
        <a-form-item class="full" :label="$t('admin.trainingRoom.area') + ':'" :colon="false">
          <a-input
            addon-after="㎡"
            oninput="value=value.replace(/[^\d^\.]+/g,'').replace('.','\$#\$').replace(/\./g,'').replace('\$#\$','.')"
            v-decorator="['area']"
            maxLength="10"
            :placeholder="$t('admin.trainingRoom.areaPlaceholder')"
          ></a-input>
        </a-form-item>
        <a-form-item class="full" :label="$t('admin.trainingRoom.constructionYear') + ':'" :colon="false">
          <a-select allowClear v-decorator="['constructionYear']" :placeholder="$t('admin.trainingRoom.selectConstructionYear')">
            <a-select-option v-for="(item, key) in yearList" :key="key" :value="item">{{ item }}{{ $t('admin.trainingRoom.year') }}</a-select-option>
          </a-select>
        </a-form-item>
      </div>
      <div class="list">
        <a-form-item class="full" :label="$t('admin.trainingRoom.capacity') + ':'" :colon="false">
          <a-input
            maxLength="4"
            oninput="value=value.replace(/[^\d]/g,'')"
            :placeholder="$t('admin.trainingRoom.capacityPlaceholder')"
            v-decorator="[
              'number',
              { rules: [{ required: true, message: $t('admin.trainingRoom.capacityError') }] }
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item class="full" :label="$t('admin.trainingRoom.status') + ':'" :colon="false">
          <a-select
            v-decorator="['status', { rules: [{ required: true, message: $t('admin.trainingRoom.selectStatus') }] }]"
            :placeholder="$t('admin.trainingRoom.selectStatus')"
          >
            <a-select-option value="1">{{ $t('admin.trainingRoom.statusEnabled') }}</a-select-option>
            <a-select-option value="2">{{ $t('admin.trainingRoom.statusDisabled') }}</a-select-option>
          </a-select>
        </a-form-item>
      </div>
      <div class="list">
        <a-form-item class="full" :label="$t('admin.trainingRoom.floor') + ':'" :colon="false">
          <a-input
            maxLength="4"
            oninput="value=value.replace(/[^\d]/g,'')"
            :placeholder="$t('admin.trainingRoom.floorPlaceholder')"
            v-decorator="['floor', { rules: [{ required: true, message: $t('admin.trainingRoom.floorRequired') }] }]"
          ></a-input>
        </a-form-item>
        <a-form-item class="full" :label="$t('admin.trainingRoom.principal') + ':'" :colon="false">
          <a-input
            maxLength="20"
            :placeholder="$t('admin.trainingRoom.principalPlaceholder')"
            v-decorator="['principal', { rules: [{ required: true, message: $t('admin.trainingRoom.principalRequired') }] }]"
          ></a-input>
        </a-form-item>
      </div>
      <div class="list">
        <a-form-item class="full" :label="$t('admin.trainingRoom.introduction') + ':'" :colon="false">
          <a-textarea
            maxLength="200"
            :placeholder="$t('admin.trainingRoom.introductionPlaceholder')"
            v-decorator="['introduction', { rules: [{ required: true, message: $t('admin.trainingRoom.introductionRequired') }] }]"
          ></a-textarea>
        </a-form-item>
        <a-form-item class="full" :label="$t('admin.trainingRoom.attributes') + ':'" :colon="false">
          <a-input
            :placeholder="$t('admin.trainingRoom.attributesPlaceholder')"
            v-decorator="['attributes', { rules: [] }]"
          ></a-input>
        </a-form-item>
      </div>
      <div class="list">
        <a-form-item class="full" :label="$t('admin.trainingRoom.photos') + ':'" :colon="false">
          <div style="width: 300px; height: 160px;">
            <Upload
              @uploadData="photosUploadOk"
              :fileUrl="form.getFieldValue('photos')"
              :accept="['png', 'jpg']"
              :desc="['', $t('admin.trainingRoom.imageFormatTip')]"
              v-decorator="['photos', {}]"
            />
          </div>
        </a-form-item>
        <a-form-item class="full" :label="$t('admin.trainingRoom.layout') + ':'" :colon="false">
          <div style="width: 300px; height: 160px;">
            <Upload
              @uploadData="layoutUploadOk"
              :fileUrl="form.getFieldValue('layout')"
              :accept="['png', 'jpg']"
              :desc="['', $t('admin.trainingRoom.imageFormatTip')]"
              v-decorator="['layout', {}]"
            />
          </div>
        </a-form-item>
      </div>
      <div class="title">{{ $t('admin.trainingRoom.permissionSettings') }}</div>
      <div class="list">
        <a-form-item class="full marginBottom0" :label="$t('admin.trainingRoom.needApproval') + ':'" :colon="false">
          <a-radio-group class="radioGroup" @change="changeColor('navigateBackground')" v-decorator="['isReview']">
            <a-radio :value="1">{{ $t('admin.trainingRoom.yes') }}</a-radio>
            <a-radio :value="2">{{ $t('admin.trainingRoom.no') }}</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item class="full marginBottom0" :label="$t('admin.trainingRoom.bookingTime') + ':'" required :colon="false">
          <div class="time_wrap">
            <div class="wd100">
              <a-form-item class="wd100_p">
                <a-time-picker
                  class="wd100"
                  @change="onChangeStart"
                  :default-open-value="moment('06:00', 'HH:mm')"
                  v-decorator="['startTime', { rules: [{ required: true, message: $t('admin.trainingRoom.selectTime') }] }]"
                  format="HH:mm"
                  :minute-step="15"
                  :disabledHours="StartHours"
                  :disabledMinutes="checkoutMin"
                  :hideDisabledOptions="true"
                >
                  <a-icon slot="suffixIcon" style="font-size: 12px" type="down" />
                </a-time-picker>
              </a-form-item>
            </div>
            <div style="margin: 0 10px">
              {{ $t('admin.trainingRoom.to') }}
            </div>
            <div class="wd100">
              <a-form-item class="wd100_p">
                <a-time-picker
                  class="wd100"
                  :default-open-value="moment('06:00', 'HH:mm')"
                  @change="onChangeEnd"
                  v-decorator="['endTime', { rules: [{ required: true, message: $t('admin.trainingRoom.selectTime') }] }]"
                  format="HH:mm"
                  :minute-step="15"
                  :disabledHours="StartHours"
                  :disabledMinutes="checkoutMin"
                  :hideDisabledOptions="true"
                >
                  <a-icon slot="suffixIcon" style="font-size: 12px" type="down" />
                </a-time-picker>
              </a-form-item>
            </div>
          </div>
        </a-form-item>
      </div>
      <div class='list'>
        <a-form-item class="full" :label="$t('admin.trainingRoom.minTimeLabel')" :colon="false">
          <a-select
            v-decorator="['minTime', { rules: [{ required: true, message: $t('admin.trainingRoom.selectMinTime') }] }]"
            :placeholder="$t('admin.trainingRoom.selectTime')">
            <a-select-option value="30">30{{ $t('admin.trainingRoom.minutes') }}</a-select-option>
            <a-select-option value="45">45{{ $t('admin.trainingRoom.minutes') }}</a-select-option>
            <a-select-option value="60">60{{ $t('admin.trainingRoom.minutes') }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item class="full" :label="$t('admin.trainingRoom.maxTimeLabel')" :colon="false">
          <a-select
            v-decorator="['maxTime', { rules: [{ required: true, message: $t('admin.trainingRoom.selectMaxTime') }] }]"
            :placeholder="$t('admin.trainingRoom.selectTime')"
          >
            <a-select-option value="120">120{{ $t('admin.trainingRoom.minutes') }}</a-select-option>
            <a-select-option value="180">180{{ $t('admin.trainingRoom.minutes') }}</a-select-option>
            <a-select-option value="240">240{{ $t('admin.trainingRoom.minutes') }}</a-select-option>
            <a-select-option value="-1">{{ $t('admin.trainingRoom.unlimited') }}</a-select-option>
          </a-select>
        </a-form-item>
      </div>
      <div class="title">{{ $t('admin.trainingRoom.equipmentDetails') }}</div>
      <div class="list">
        <div class="table">
          <div class="table_wrap">
            <div class="table_title table_title_left">
              <div>{{ $t('admin.trainingRoom.equipmentName') }}</div>
              <div>{{ $t('admin.trainingRoom.equipmentCount') }}</div>
            </div>
            <div
              class="table_title"
              :class="{ wd100: item.name == $t('admin.trainingRoom.noData') }"
              v-for="item in equipmentList"
              :key="item.id"
            >
              <div class="table_title_name" :style="{ maxWidth: item.name == $t('admin.trainingRoom.noData') ? '100%' : '' }">
                <a-tooltip>
                  <template slot="title">
                    {{ item.name }}
                  </template>
                  {{ item.name }}
                </a-tooltip>
              </div>
              <div
                class="table_title_num"
                :style="{
                  maxWidth: item.number == $t('admin.trainingRoom.noData') ? '100%' : '',
                  color: item.number == $t('admin.trainingRoom.noData') ? '#6B738C' : ''
                }"
              >
                <span> {{ item.number }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="submit-button">
        <a-button type="primary" @click="handleSubmit">{{ $t('admin.trainingRoom.submit') }}</a-button>
      </div>
    </a-form>
  </div>
</template>

<script>
import cookie from 'js-cookie'
import moment from 'moment'
import { postTrainingRoomSave, getTrainingRoomDetail, getTrainingEquipmentUsableList } from '@/api/admin'
import Upload from '@/components/upload/index.vue'

export default {
  components: {
    Upload
  },
  data() {
    return {
      moment,
      id: undefined,
      passwordFlag: false,
      repasswordFlag: false,
      passwordModal: false,
      oldpasswordFlag: false,
      noPermissionModal: false,
      passwordConfirmLoading: false,
      form: this.$form.createForm(this),
      user: cookie.getJSON('user_infor'),
      userRoles: cookie.getJSON('user_type'),
      shortName: '@' + cookie.getJSON('user_infor').username.split('@')[1],
      startTime: '',
      endTime: '',
      yearList: [],
      equipmentList: []
    }
  },
  computed: {},
  methods: {
    StartHours() {
      return [0, 1, 2, 3, 4, 5, 24]
    },
    checkoutMin(arr) {
      if (arr == 23) {
        let arr = []
        for (let i = 1; i < 60; i++) {
          arr.push(i)
        }
        return arr
      } else {
        return []
      }
    },
    onChangeStart(el, al) {
      this.startTime = al
      this.form.setFieldsValue({
        endTime: ''
      })
    },
    changeColor(key) {
      this.form[key] = this[key + 'Has'] ? '#ffffff' : ''
    },
    onChangeEnd(el, al) {
      console.log(al)
      var str_date = this.startTime;
      if(this.getDate(str_date) - this.getDate(al) > 0 && al !== '') {
        this.$message.error(this.$t('admin.trainingRoom.endTimeError'))
        setTimeout(() => {
          this.form.setFieldsValue({
            endTime: ''
          })
        }, 150)
      } else if(al.split(':')[0] == '23' && al.split(':')[1] !== '00') {
        this.$message.error(this.$t('admin.trainingRoom.endTimeLimit'))
        setTimeout(() => {
          this.form.setFieldsValue({
            endTime: ''
          })
        }, 150)
      } else {
        this.endTime = al
      }
    },
    // 时间对比
    getDate(date) {
      let dates = date.split(':')
      let dateReturn = ''
      for (let i = 0; i < dates.length; i++) {
        dateReturn += dates[i]
      }
      return dateReturn
    },
    back() {
      this.$router.go(-1)
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          values.startTime = this.startTime
          values.endTime = this.endTime
          if (values.constructionYear !== undefined) {
            values.constructionYear = String(values.constructionYear)
          }
          if (this.getDate(this.endTime) - this.getDate(this.startTime) < values.minTime) {
            this.$message.error(this.$t('admin.trainingRoom.bookingTimeError'))
            return
          }
          if (this.id) {
            values.id = this.id
          }
          console.log(values)
          postTrainingRoomSave(values).then(res => {
            if (res.code == 200) {
              const tip = this.id ? this.$t('admin.trainingRoom.editSuccess') : this.$t('admin.trainingRoom.createSuccess')
              this.$message.success(tip)
              this.$router.go(-1)
            }
          })
        }
      })
    },
    getTrainingRoomDetailHttp() {
      getTrainingRoomDetail({ id: this.id }).then(res => {
        if (res.code == 200) {
          this.startTime = res.data.startTime
          this.endTime = res.data.endTime
          this.form.setFieldsValue({
            name: res.data.name,
            place: res.data.place,
            area: res.data.area,
            constructionYear: res.data.constructionYear.toString() || [],
            number: res.data.number,
            status: res.data.status.toString(),
            isReview: res.data.isReview,
            startTime: moment(res.data.startTime, 'HH:mm'),
            endTime: moment(res.data.endTime, 'HH:mm'),
            minTime: res.data.minTime.toString(),
            maxTime: res.data.maxTime.toString(),
            photos: res.data.photos,
            layout: res.data.layout,
            floor: res.data.floor,
            principal: res.data.principal,
            introduction: res.data.introduction,
            attributes: res.data.attributes
          })
        }
      })
    },
    getYear(params) {
      // 获取指定开始的年份到现在年的数组
      //获取到从那一年开始
      let yearList = []
      let smallYears = params
      //获取当前时间
      let date = new Date()
      let nowYears = date.getFullYear()
      var Years = nowYears - smallYears
      let arrYear = []
      for (let i = 0; i <= Years; i++) {
        arrYear.push(nowYears--)
      }
      arrYear.forEach(ele => {
        yearList.push(ele)
      })
      return yearList
    },
    // 关联设备
    getTrainingEquipmentUsableListHttp() {
      getTrainingEquipmentUsableList({ trainingRoomId: this.id }).then(res => {
        if (res.code == 200) {
          console.log(res)
          if (res.data.list.length > 0) {
            this.equipmentList = res.data.list
          }else{
            this.equipmentList = [{ name: this.$t('admin.trainingRoom.noData'), number: this.$t('admin.trainingRoom.noData') }]
          }
        }
      })
    },
    photosUploadOk(data) {
      this.form.setFieldsValue({
        photos: data[0] ? data[0].url : ''
      })
    },
    layoutUploadOk(data) {
      this.form.setFieldsValue({
        layout: data[0] ? data[0].url : ''
      })
    }
  },
  mounted() {
    this.id = this.$route.query.id || undefined
    if (this.id) {
      this.getTrainingRoomDetailHttp()
      this.getTrainingEquipmentUsableListHttp()
    } else {
      this.equipmentList = [{ name: '暂无数据', number: '暂无数据' }]
      this.form.setFieldsValue({
        isReview: 2
      })
    }
    this.yearList = [...this.getYear(1900)]
  }
}
</script>

<style lang="less" scoped>
h4 {
  font-size: 16px;
  font-weight: 800;
  color: #000000;
  line-height: 22px;
}
.admin {
  width: 100%;
  cursor: pointer;
  text-align: right;
  margin-bottom: 21px;
  .user-logo {
    width: 26px;
    height: 26px;
    border-radius: 100%;
    margin-right: 12px;
  }
  .down {
    width: 10px;
    margin-left: 5px;
  }
}
/deep/.ant-input-suffix {
  right: 12px;
  img {
    width: 23px;
    cursor: pointer;
  }
}
.back {
  width: 80px;
  height: 34px;
  display: flex;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  border-radius: 25px;
  margin-top: 16px;
  margin-bottom: 26px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d6d6d6;
  img {
    height: 10px;
    margin-right: 9px;
  }
}
/deep/.ant-form {
  .title {
    display: flex;
    font-size: 14px;
    font-weight: 600;
    color: #627587;
    line-height: 20px;
    position: relative;
    padding: 12px 17px;
    margin-bottom: 30px;
    align-items: center;
    border-bottom: 1px solid #ededed;
    &::before {
      left: 0;
      content: '';
      width: 4px;
      height: 12px;
      border-radius: 2px;
      position: absolute;
      background: #6b738c;
    }
  }

  .list {
    display: flex;
    //padding-right: 200px;
    .ant-form-item-label label {
      color: #000000;
    }
    .ant-form-item {
      width: 50%;
      padding-left: 45px;
      &:first-child {
        padding-left: 0;
        padding-right: 45px;
      }
    }
    .ant-input-affix-wrapper .ant-input-suffix {
      position: absolute;
      img {
        width: 23px;
        height: 23px;
      }
    }
    .ant-calendar-picker div {
      position: relative;
      .ant-calendar-picker-input {
        width: 228px;
        height: 35px;
        margin-right: 0;
        color: #000000;
        border-radius: 4px;
        background: #ffffff;
        border: 1px solid #d8dce0;
      }
    }
    .ant-input,
    .ant-select {
      //border-radius: 20px;
      color: #000000;
    }
    .full .ant-input,
    .full .ant-select {
      width: 100%;
      height: 35px;
      color: #000000;
      margin-right: 0;
      //border-radius: 20px;
    }
    .ant-input-group-addon {
      border-top-right-radius: 4px !important;
      border-bottom-right-radius: 4px !important;
    }
    .ant-input-wrapper.ant-input-group {
      .ant-input {
        border-right: 0;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
      .ant-input-group-addon {
        background: #fff;
        font-size: 14px;
        font-weight: 400;
        color: #5e7a92;
        line-height: 20px;
        border-top-right-radius: 20px;
        border-bottom-right-radius: 20px;
      }
    }
  }
  .submit-button {
    width: 100%;
    // padding-left: 500px;
    text-align: center;
    margin-top: 50px;
  }
}

.time_wrap {
  width: 100% !important;
  display: flex;
  justify-content: space-between;
}
.wd100 {
  width: 100% !important;
  .table_title_name {
    text-align: left !important;

    font-size: 14px;
    color: #b1b1b1;
    span {
      padding-left: 30px;
    }
  }
  .table_title_num {
    text-align: left !important;
    padding-left: 40px;
    font-size: 14px;
    span {
      color: #b1b1b1;
    }
  }
}
.wd100_p {
  width: 100% !important;
  padding-right: 0 !important;
}
.table {
  overflow-x: auto;
  overflow-y: hidden;
  width: 100%;
  border-radius: 6px;
  //box-shadow: 0px 0px 1px 0px #3e3e3e;
}
.table_wrap {
  max-height: 98px;
  height: 96px;
  display: flex;
  //border: 1px solid #E2E5E7;
  //border-right: 1px solid #E2E5E7;
  //border-left: 1px solid #E2E5E7;
  box-sizing: border-box;
  border-radius: 6px;
  width: 100%;
  font-size: 14px;
  color: #6b738c;
  &::-webkit-scrollbar {
    height: 10px;
  }
  .table_title div {
    height: 48px;
    line-height: 48px;
    min-width: 150px;
    max-width: 150px;
    text-align: center;
  }
  .table_title > div:nth-child(1) {
    border-top: 1px solid #e2e5e7;
    border-bottom: 1px solid #e2e5e7;
    border-right: 1px solid #e2e5e7;
    box-sizing: border-box;
  }
  .table_title > div:nth-child(2) {
    border-right: 1px solid #e2e5e7;
    box-sizing: border-box;
    border-bottom: 1px solid #e2e5e7;
  }
  .table_title_left {
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    div {
      white-space: nowrap;
      background: #edf2f6;
    }
  }
  .table_title_name {
    padding: 0 12px;
    margin: 0 auto;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .table_title_num {
    color: #000;
  }
  & > div:first-child {
    & > div:nth-child(1) {
      border-top-left-radius: 6px;
    }
    & > div:nth-child(2) {
      border-bottom-left-radius: 6px;
    }
  }
  & > div:last-child {
    .table_title_name {
      border-top-right-radius: 6px;
    }
    .table_title_num {
      border-bottom-right-radius: 6px;
    }
  }
}
.marginBottom0 {
  margin-bottom: 0;
}
/deep/ .ant-form .list .ant-form-item-label label {
  font-weight: 600;
}
@media (max-width: 1440px) {
  .ant-form .list {
    padding-right: 0 !important;
  }
}
</style>
